import * as Sentry from '@sentry/react';

export function assert(condition: unknown, msg?: string): asserts condition {
  if (!condition) {
    Sentry.captureException(new Error(msg));
    throw new Error(msg);
  }
}
